import gql from 'graphql-tag';

const getResourceHistoryQuery = gql`
  query GetResourceHistory ($resourceId: String!, $eventFilter: String, $isInternalEventsVisible: Boolean) {
    getResourceHistory (resourceId: $resourceId, eventFilter: $eventFilter, isInternalEventsVisible: $isInternalEventsVisible) {
      resourceId
      eventId
      eventType
      createdAt
      metaData
      createdByUser {
        userId
        firstName
        lastName
      }
    }
  }
`;

const getResourceHistory = () => ({
  query: getResourceHistoryQuery,
  module: 'history',
  ignoreCache: true,
  buildVariables: (resourceId, isInternalEventsVisible) => ({
    resourceId,
    isInternalEventsVisible
  })
});

export default getResourceHistory;